import React, { useState } from "react";
import DOMPurify from "dompurify";

export default function HTMLContents({ data }) {
  const [showFull, setShowFull] = useState(false);

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const decodedData = DOMPurify.sanitize(decodeHtml(data || ""));
  const shouldShowToggle = decodedData.length > 600;

  return (
    <>
      <style>
        {`
          .html-content, .html-content p {
            color: #686868 !important;
          }
           

          .html-content.truncate {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
          }

          .view-toggle {
            color: #007bff;
            cursor: pointer;
            font-weight: 500;
            margin-top: 5px;
            display: inline-block;
          }
        `}
      </style>

      {data && (
        <>
          <div
            className={`html-content ${!showFull ? "truncate" : ""}`}
            dangerouslySetInnerHTML={{ __html: decodedData }}
          />

          {shouldShowToggle && (
            <span
              className="view-toggle "
              onClick={() => setShowFull((prev) => !prev)}
            >
              {showFull ? "Read Less" : "Read More"}
            </span>
          )}
        </>
      )}
    </>
  );
}
